import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const cache = new Map();

export function usePhotoUrl(user) {
  const [url, setUrl] = useState(null);
  useEffect(() => {
    if (!user?.photo_path) return setUrl(null);
    let alive = true;
    if (!cache.has(user.photo_path)) {
      cache.set(user.photo_path, api.get(`/photos/${user.user_id}`, { responseType: "blob" }).then((r) => URL.createObjectURL(r.data)));
    }
    cache.get(user.photo_path)
      .then((u) => alive && setUrl(u))
      .catch(() => {
        cache.delete(user.photo_path);
        if (alive) setUrl(null);
      });
    return () => { alive = false; };
  }, [user?.user_id, user?.photo_path]);
  return url;
}

export const getLocation = () =>
  new Promise((resolve) => {
    if (!navigator.geolocation) return resolve(null);
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 },
    );
  });

export const mapsUrl = (loc) => `https://www.google.com/maps?q=${loc.lat},${loc.lng}`;

export const fmtCoord = (loc) => `${loc.lat.toFixed(6)}, ${loc.lng.toFixed(6)}`;
